import { render, staticRenderFns } from "./RutePenyebranganDetail.vue?vue&type=template&id=9220eaba&scoped=true"
import script from "./RutePenyebranganDetail.vue?vue&type=script&lang=js"
export * from "./RutePenyebranganDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9220eaba",
  null
  
)

export default component.exports